/** v0.5 ② (D-761/§5-6): taxonomy nodes (id/label/parent_id のフラット配列、`GET /masters/taxonomy/:entityType`
 *  のレスポンス) から「直近の親1段だけの接頭辞」と「全経路 (aria-label 用)」を組み立てる。
 *  保有していない祖先までツリー化すると「持っていないスキルを持っているように見える」ため、
 *  読み取り専用画面 (TalentSkillsPage/MySkillsPage/TalentCertificationsPage) は接頭辞表示に留める。 */
export type TaxonomyBreadcrumbNode = { id: string; label: string; parent_id: string | null };

export const buildSkillBreadcrumb = (
  nodes: TaxonomyBreadcrumbNode[], skillId: string,
): { immediateParent: string | null; fullPath: string } => {
  const byId = new Map(nodes.map((n) => [n.id, n]));
  const path: string[] = [];
  let current = byId.get(skillId);
  while (current) { path.unshift(current.label); current = current.parent_id ? byId.get(current.parent_id) : undefined; }
  return { immediateParent: path.length > 1 ? path[path.length - 2]! : null, fullPath: path.join(' › ') };
};
